//#region OBJECTS
export const MENU_ADICCIONES = {
    DESELECCIONAR: 0,
    INGRESO_SOLICITUD: 1,
    GESTION_SOLICITUD: 2
};

export const STEPPER_ADICCIONES = {
    BUSCAR_AFILIADO: 0,
    DATOS_AFILIADO: 1,
    DETALLES_ORDEN: 2,
    COMPLEMENTO_ORDEN: 3,
    DIAGNOSTICO_DOCUMENTACION: 4,
    PRACTICAS: 5,
    // CONFIRMACION: 6,
};

export const STEPPER_INTEGRACION_AUTO_G = {
    BUSCAR_AFILIADO: 0,
    DETALLES_ORDEN: 1,
    COMPLEMENTO_ORDEN: 2,
    DIAGNOSTICO_DOCUMENTACION: 3,
};

export const AUTORIZACIONES_INTEGRACION_MENU_HISTORIAL = {
    SOLICITUD: 0,
    PRACTICA: 1,
    TRANSPORTE: 2,
    TERAPIA: 2,
}

export const INTEGRACION_MENU_AUDITORIA = {
    AFILIADO: 0,
    ADMINISTRAR: 1,
    INFORMACION: 2,
    COMPLEMENTO_INFORMACION: 3,
    DOCUMENTACION: 4,
    DIAGNOSTICO_PRACTICA: 5,
    NOTAS: 6
};

export const TIPO_SOLICITUD_INTEGRACION = {
    HOGAR: 1,
    ESCUELAS: 2,
    TRANSPORTE: 3,
    TERAPIA_INDIVIDUAL: 4,
    TERAPIA_MODULO: 5,
}

export const SUBTIPO_SOLICITUD_INTEGRACION = {
    INTEGRACION_ESCOLAR: 1,
    ESCOLARIDAD_ESPECIAL: 2,
    CET_CD: 3,
    ESPECIAL_A_INSTITUCION: 4,
    ESPECIAL_A_TRATAMIENTOS: 5,
    PROFESIONAL_INDEPENDIENTE: 6,
    MODULO_INTEGRAL_SIMPLE: 7,
    MODULO_INTEGRAL_INTENSIVO: 8,
    MODULO_ESTIMULACION: 9
}

export const ESTADO_SOLICITUD_ADICCIONES = {
    EN_CARGA: 3,                //SOLO PARA EL ADMINISTRATIVO
    EN_CARGA_AFILIADO: 1,       //SOLO PARA EL AFILIADO
    AUDITORIA_ADMINISTRATIVA: 2,
    PENDIENTE_AUTORIZACION: 4,
    AUTORIZADA: 5,
    RECHAZADA: 6,
    CANCELADA: 7,
}
//#endregion


//#region OBJECTS
export const EMITIDO_POR_LIST = [
    { id: 1, descripcion: "Nación" },
    { id: 2, descripcion: "Provincia" },
    { id: 3, descripcion: "CABA" },
]

export const TIPO_DISCAPACIDAD_LIST = [
    { id: 1, descripcion: "Auditiva" },
    { id: 2, descripcion: "Visual" },
    { id: 3, descripcion: "Mental" },
    { id: 4, descripcion: "Motora" },
    { id: 5, descripcion: "Visceral " }
]

export const FRECUENCIA_DISCAPACIDAD_LIST = [
    { id: 1, descripcion: "Definitiva" },
    { id: 2, descripcion: "Transitoria" },
]

export const ALCANCE_DISCAPACIDAD_LIST = [
    { id: 1, descripcion: "Parcial" },
    { id: 2, descripcion: "Total" },
]
//#endregion